<template>
  <a
    href="javascript:void(0)"
    class="mode-toggle"
    :title="esOscuro ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'"
    :aria-label="esOscuro ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'"
    @click="alternarModo"
  >
    <vue-feather :type="esOscuro ? 'sun' : 'moon'" size="20" />
  </a>
</template>

<script>
const OSCURO = "dark-only";
const CLARO = "light-only";

export default {
  name: "ModeView",
  data() {
    return {
      modo: localStorage.getItem("layoutVersion") === OSCURO ? OSCURO : CLARO,
    };
  },
  computed: {
    esOscuro() {
      return this.modo === OSCURO;
    },
  },
  methods: {
    alternarModo() {
      this.modo = this.esOscuro ? CLARO : OSCURO;
      this.$store.dispatch("layout/setLayout", this.modo);
    },
  },
};
</script>

<style scoped>
.mode-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: inherit;
  cursor: pointer;
}
</style>
